import React from 'react';

export interface ScreenPerfContextValue {
  registerLoading: (id: string, getIsLoading: () => boolean) => () => void;
  notifyLoadingChange: () => void;
}

export const ScreenPerfContext = React.createContext<ScreenPerfContextValue | null>(null);
